import { api_private_post, showAlert } from "script";

function handleBuyClick(qty) {
  // make sure it's an integer
  const quantity = parseInt(qty, 10);

  if (!quantity || quantity <= 99) {
    showAlert("Invalid quantity of credits.", "danger");
    return;
  }

  api_private_post(
    "/payments/create_stripe_checkout_session",
    { product: "credits", quantity: quantity },
    (data) => {
      console.log("create_stripe_checkout_session:", data);

      // backend sends { error: "..." } on failure
      if (data && data.error) {
        showAlert(data.error, "danger");
        return;
      }

      if (data && data.url) {
        // Stripe Checkout URL → redirect user to payment page
        window.location.href = data.url;
      } else {
        showAlert("Failed to create checkout session.", "danger");
      }
    },
  );
}

const ShoppingProduct = ({ category, title, description, buttonText, qty }) => {
  return (
    <div className="col-xxl-6">
      <div className="Promotions__card d-flex align-items-center justify-content-center justify-content-sm-between flex-wrap flex-sm-nowrap gap-6 p-2 p-lg-4 rounded-8 p3-bg">
        <div
          className="Promotions__card-thumb text-center p-0 m-0"
          style={{ transform: "rotate(-76deg)" }}
        >
          <img src={`/assets/images/credits_${qty}.png`} alt="Icon" />
        </div>
        <div className="Promotions__card-content text-center text-sm-start">
          <h5 className="mb-3">{category}</h5>
          <span className="fs-three mb-2 mb-md-3 d-block">{title}</span>
          <span className="fs-six mb-4 mb-md-5 d-block opacity-50">
            {description}
          </span>
          <button
            onClick={() => handleBuyClick(qty)}
            type="button"
            className="cmn-btn px-5 py-3"
          >
            {buttonText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ShoppingProduct;
